import { Content } from 'antd/es/layout/layout';
import * as React from 'react';
import { CardIcon } from '../../../../utils/dict/CardType';
import styles from './styles.module.scss';
interface HeaderProps {
  type: string;
  numberOfItems: any;
  name: string;
}
//Generic header component for a card. It contains the icon and title of a card.
const CardHeader: React.FC<HeaderProps> = ({
  type,
  numberOfItems,
  name
}: HeaderProps): JSX.Element => {
  return (
    <div>
      <img src={CardIcon[type]} style={{ position: 'absolute', top: '21px', width: "1.4em", height: "auto" }} />
      <h1
        className={styles.header}
        style={{ marginLeft: '36px', color: '#005E8C' }}
      >
        {name}
      </h1>
      <p className={styles['item-number']}>{numberOfItems}</p>
    </div>
  );
};

export default CardHeader;
